// Module
var code = "<div> <div style=\"margin-left:2rem\"> <h3>You have been logged out</h3> <p>Your session has expired. Please log in to continue.</p> <div class=\"top24\"> <button @click.stop.prevent=\"login()\">Click here to login</button> </div> </div> </div> ";
// Exports
export default code;